import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Hitchhiking",
  "description": "",
  "published": "2006-07-17T00:00:00.000Z",
  "redirect_from": ["/blog/hitchhiking/swizec/396"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A few days ago, on Thursday to be precise, I stepped into the magnificent bookstore thing I usually go to in order to get my fix and there it was, waiting for me, the book I had ordered, The Ultimat Hitchhiker's Guide. It's an amazingly well written book with lots of funny little twists and turns and it even makes one laugh a lot. This edition supposedly has 5 novels and a story inside... so that's quite some reading material. 800 pages worth in fact.`}</p>
    <p>{`On the other hand there is mister Cthulhu, he has been calmly waiting under my bed to get another issue published and I assure you I am working full steam on it... well almost, I do take way too many breaks, anyway the issue is progressing and is turning out quite lovely. So just remain patient eh.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      